var _defs, _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _rect7, _rect8, _rect9, _path5, _rect0, _path6, _rect1, _rect10, _path7, _rect11, _rect12, _path8, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnroundsLogoSymbolOnly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.68 144.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7de8bc;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24{stroke-width:0px;}.cls-2{fill:#0a98cf;}.cls-3{fill:#fa7902;}.cls-4{fill:#065280;}.cls-5{fill:#64d1da;}.cls-6{fill:#78012c;}.cls-7{fill:#34b2e3;}.cls-8{fill:#8c103d;}.cls-9{fill:#68cbf2;}.cls-10{fill:#f06e7a;}.cls-11{fill:#e24956;}.cls-12{fill:#ff912b;}.cls-13{fill:#ffda8c;}.cls-14{fill:#ffa757;}.cls-15{fill:#2070a1;}.cls-16{fill:#38c98d;}.cls-17{fill:#fab320;}.cls-18{fill:#64daa9;}.cls-19{fill:#0a4366;}.cls-20{fill:#91e5eb;}.cls-21{fill:#2cc6d2;}.cls-22{fill:#a6325c;}.cls-23{fill:#cc2331;}.cls-24{fill:#ffca59;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m48.22,0h-7.6c-6.07,0-11.01,4.94-11.01,11.01v15.2h18.61V0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 48.22,
    width: 18.61,
    height: 26.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.83,
    width: 18.61,
    height: 26.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 18.61,
    y: 29.62,
    width: 18.61,
    height: 26.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.61,29.62h-7.6c-6.07,0-11.01,4.94-11.01,11.01v15.2h18.61v-26.2Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.21,
    y: 29.62,
    width: 18.61,
    height: 26.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 77.84,
    width: 26.2,
    height: 18.61
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m26.2,96.45H0v7.6c0,6.07,4.94,11.01,11.01,11.01h15.2v-18.61Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    y: 59.24,
    width: 26.2,
    height: 18.61
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m29.62,133.67c0,6.07,4.94,11.01,11.01,11.01h15.2v-18.61h-26.2v7.6Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 29.62,
    y: 107.46,
    width: 26.2,
    height: 18.61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.62,
    y: 88.86,
    width: 26.2,
    height: 18.61
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 59.24,
    y: 118.47,
    width: 18.61,
    height: 26.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m96.45,144.68h7.6c6.07,0,11.01-4.94,11.01-11.01v-15.2h-18.61v26.2Z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.84,
    y: 118.47,
    width: 18.61,
    height: 26.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m126.07,115.06h7.6c6.07,0,11.01-4.94,11.01-11.01v-15.2h-18.61v26.2Z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 107.46,
    y: 88.86,
    width: 18.61,
    height: 26.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 88.86,
    y: 88.86,
    width: 18.61,
    height: 26.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m144.68,40.62c0-6.07-4.94-11.01-11.01-11.01h-15.2v18.61h26.2v-7.6Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 118.47,
    y: 48.22,
    width: 26.2,
    height: 18.61
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 118.47,
    y: 66.83,
    width: 26.2,
    height: 18.61
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m115.06,11.01c0-6.07-4.94-11.01-11.01-11.01h-15.2v18.61h26.2v-7.6Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.86,
    y: 37.21,
    width: 26.2,
    height: 18.61
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 88.86,
    y: 18.61,
    width: 26.2,
    height: 18.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnroundsLogoSymbolOnly);
export default __webpack_public_path__ + "static/media/onrounds-logo-symbol-only.24b3e8ff3d0bd6d73c7745843ad5f8fc.svg";
export { ForwardRef as ReactComponent };